<template>
  <md-toolbar md-elevation="0" class="logged-header" data-cy="nfHeader">
    <div ref="tourOverlay" :class="[{ 'tour-overlay': showOverlay }]"></div>
      <div class="container md-toolbar-row">
        <SLogo class="py-2" :class="[{ 'display-none': displayNone }]"/>
        <SHeaderMenu
          v-if="!mobileScreen"
          :class="[{ 'display-none': displayNone, 'ml-3': !mobileScreen }]"
          :key="componentKeyHeader"
          @changeKey="changeKey"
        />
        <SHeaderMobileMenu
          v-else
          :userId="userId"
        />
        <SSearchTopBar class="desktop-search m-auto" />
        <SSearchTopBar
          class="mobile-search md-toolbar-row mobile-search-row"
          :class="[{ 'expand': displayNone }]"
          @focusIn="focusIn"
          @focusOut="focusOut"
        />
        <SButtonMaterial
          class="wishlist-button"
          buttonType="button"
          color="primary"
          textColor="white"
          materialClass="dense"
          iconWithoutText="favorite"
          iconColor="white"
          @button="goToWishlist"
          data-cy="headerWishlistButton"
        />
        <SHeaderMessages
          ref="sHeaderMessages"
          class="ml-3"
          :class="[{ 'display-none': displayNone,}]"
          :key="componentKeyMessages"
          @changeKey="changeKey"
        />
        <SHeaderNotifications
          :key="componentKeyNotification"
          :class="[{ 'display-none': displayNone, 'ml-3': !mobileScreen }]"
          @changeKey="changeKey"
        />
        <SButtonMaterial
          :class="[{ 'display-none': displayNone, 'ml-3': !mobileScreen }, { 'post-mobile-button': mobileScreen, 'post-desktop-button': !mobileScreen }]"
          buttonType="button"
          color="primary"
          textColor="white"
          materialClass="dense"
          :text="mobileScreen ? '' : 'post item'"
          :iconWithoutText="mobileScreen ? 'add' : ''"
          :iconLeftText="mobileScreen ? '' : 'add'"
          iconColor="white"
          @button="openNewItemModal"
          data-cy="headerPostItem"
        />
        <SHeaderProfileMenu
          ref="headerUserProfile"
          :userName="userName"
          :profileUserName="profileUserName"
          :userId="userId"
          class="ml-2 profile-icon-header"
          :class="[{ 'ml-3': !mobileScreen }]"
          :key="componentKeyProfile"
          @changeKey="changeKey"
        />
      </div>
    <HeaderTour
      @onFinishTour="exitTour"
      :dontShow="dontShowModalAgain"
    />
  </md-toolbar>
</template>

<script>
import SLogo from "@/material-components/atoms/SLogo.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import SSearchTopBar from "@/material-components/organisms/SSearchTopBar.vue";
import SHeaderMenu from "@/material-components/atoms/SHeaderMenu.vue";
import SHeaderProfileMenu from "@/material-components/atoms/SHeaderProfileMenu.vue";
import SHeaderNotifications from "@/material-components/atoms/SHeaderNotifications.vue";
import HeaderTour from "@/material-components/molecules/HeaderTour.vue";
import modalType from "@/enum/modal-type";
import UserHelperVue from "@/mixins/UserHelper.vue";
import SHeaderMessages from "@/material-components/atoms/SHeaderMessages.vue";
import SHeaderMobileMenu from '../material-components/atoms/SHeaderMobileMenu.vue';

export default {
  name: "SLoggedHeader",
  props: ["userId", "userName", "profileUserName"],
  components: {
    SLogo,
    SButtonMaterial,
    SSearchTopBar,
    SHeaderMenu,
    SHeaderProfileMenu,
    SHeaderNotifications,
    HeaderTour,
    SHeaderMessages,
    SHeaderMobileMenu
},
  mixins: [UserHelperVue],
  data() {
    return {
      componentKey: 0,
      dontShowModalAgain: true,
      isTourFinished: false,
      displayNone: false,
    };
  },
  computed: {
    componentKeyHeader() {
      return this.componentKey;
    },
    componentKeyNotification() {
      return this.componentKey + 1;
    },
    componentKeyProfile() {
      return this.componentKey + 2;
    },
    componentKeyMessages(){
      return this.componentKey + 3;
    },
    showOverlay() {
      return !this.dontShowModalAgain && !this.isTourFinished;
    },
    mobileScreen() {
      return window.outerWidth < 1112
    }
  },
  methods: {
    focusIn() {
      this.displayNone = true
    },
    focusOut() {
      this.displayNone = false
    },
    changeKey() {
      this.componentKey++;
    },
    goToWishlist() {
      this.$router.push(`/s-app/profile-page/${this.loggedUser.id}/wishlist`);
    },
    openNewItemModal() {
      if (
        this.$route.path.includes("item-review") &&
        this.$route.query.edit === "true"
      ) {
        const itemId = this.$route.query.item_id;
        if (itemId) {
          this.$router.push(`/s-app/item-details/${itemId}`);
        }
        setTimeout(() => {}, 1000);
      }

      $("#new-item").modal("show");
    },
    async getDontShowOption() {
      const userTourModal = {
        modalType: modalType.HEADER_TOUR,
        userId: this.userId,
      };
      let response = await this.getDontShowModal(userTourModal);
      this.dontShowModalAgain = response.dontShowModal;
      if (!this.dontShowModalAgain) {
        this.$tours["HeaderTour"].start();
      }
    },
    exitTour(value) {
      this.isTourFinished = value;
    },
  },
  mounted() {
    setTimeout(() => {
      this.getDontShowOption();
    }, 1001);
  },
};
</script>

<style scoped>
.md-toolbar-section-end .mouse-leave .dropwown .md-icon-button {
margin-right: 16px !important;
}
.logged-header {
  height: 64px;
  position: fixed;
  width: 100%;
  z-index: 19;
  padding: 0 54px;
  top: 0;
}
.container {
  z-index: 20 !important;
  max-width: 100%;
  padding: 0px;

}
.post-mobile-button {
  min-width: unset;
  height: 42px;
  border-radius: 4px;
}
.wishlist-button {
  max-width: 48px;
  min-width: 48px;
  max-height: 48px;
  min-height: 48px;
}

.post-desktop-button {
  height: 50px;
}

@media screen and (min-width: 480px) {
  .post-mobile-button {
    width: 46px;
    height: 46px;
  }
}
@media screen and (min-width: 720px) {
  .post-mobile-button {
    width: 50px;
    height: 50px;
  }
}
.tour-overlay {
  background-color: rgba(0, 0, 0, 50%);
  content: "";
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  height: 2000px;
  cursor: pointer;
}
.desktop-search {
  width: 40%;
  display: none;
}

.mobile-search {
  width: 100%;
}

@media screen and (max-width: 1111px) {
  .container {
    justify-content: space-between;
  }
  .logged-header {
    padding: 0 10px;
  }
  .profile-icon-header {
    display: none;
  }
}
@media screen and (max-width: 1111px) {
  .mobile-search .mobile-search-row {
    display: block;
  }
  .md-toolbar-row.mobile-search-row {
    display: flex;
    justify-content: center;
    width: unset;
  }
  .md-toolbar-row.mobile-search-row.expand {
    width: 100%;
    transition: all 1s ease;
  }
  .md-toolbar-section-start.display-none {
    display: none;
  }
  .display-none {
    display: none;
  }
  .md-toolbar-section-end.display-none {
    display: none;
  }
  .md-toolbar-row.mobile-search-row .mobile-search {
    width: 80%;
  }
  .desktop-search {
    display: none;
  }
}
@media screen and (min-width: 1112px) {
  .desktop-search {
    display: block;
  }
  .mobile-search,
  .mobile-search-row {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.logged-header {
  background-color: $light;
}
</style>
